module.exports = __webpack_public_path__ + "fonts/bottom-line.svg";